import React, {Component} from 'react';
import { faClockFour, faVideo,faQuestionCircle , faBook , faGears, faArrowLeft, faBookOpen} from "@fortawesome/free-solid-svg-icons";
import { Card, Row, Col, Container, ListGroup,Button,Image } from "react-bootstrap";
import courseImg from "../../../assets/course_img/default_course_cover.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import apiPreshift from '../../../api/apiPreshift';
import TopicFlowViewer from '../../screens/electronicCourses/TopicFlowViewer';
export default function LessonViewer(props) {
    const [modalShow, setModalShow] = React.useState(false);
    const [targetTopic, setTargetTopic] = React.useState(null);
     const [currentFlow, setFlow] =  React.useState(null);    
    let lesson = props.current_lesson;
    const showTopicDitaiks = (topic) => {
        setModalShow(true);
        setTargetTopic(topic)
    }
    const handleChangeContent = () =>{
        props.handleChangeContent('viewCourse');
    }
    const loadFlow = (flowUuid)=>{
            return new Promise((resolve, reject) => {                                                             
                apiPreshift.getFlowWithOutEmployees(flowUuid)
                .then(response => {                            
                    if(response.data[0]){
                    setFlow(response.data[0]);                
                    }
                    resolve();
                })
                .catch(e => {
                    console.log(e);
                })
                .finally(() => console.log('finaly local flow'))
            })
        } 
    return(<Container style={{overflow:"auto"}}>
        <Row>
            <Col>
                <Card>
                    <Card.Body style={{display:"flex",justifyContent: "space-between"}}>
                        {lesson.title}
                        <Button className='bg-green' style={{borderRadius:"0",backgroundColor:"#1E874A", borderColor:"#1E874A"}} onClick={()=>{handleChangeContent()}}><FontAwesomeIcon icon={faArrowLeft} className='mr-1'/>{props.t("Back to course")} </Button>
                    </Card.Body>
                </Card>
            </Col>
        </Row>
        <Row className="mt-5">
             {Array.prototype.map.call(lesson.topics, function(topic,index){
                return <Col xs={12} sm={6} md={6} lg={4} xl={4} className="mb-5" key={index}>
                            <Card title={topic.description??props.t("This topic has no no description")}>                                
                                <Card.Body>
                                    <Row>
                                        <Col xs={3} sm={3} md={3} lg={3} xl={3}>
                                            <Image className="w-100" src={topic.file??courseImg} rounded />
                                        </Col>
                                        <Col xs={9} sm={9} md={9} lg={9} xl={9}>
                                            <Card.Title>{topic.title}</Card.Title>
                                            <ListGroup className="list-group-flush" horizontal>
                                                <ListGroup.Item title={props.t("It takes time to complete in minutes")}><FontAwesomeIcon icon={faClockFour}/>{topic.passage_time}</ListGroup.Item>
                                                <ListGroup.Item><FontAwesomeIcon icon={faVideo} title={props.t("The number of videos used in the topic")}/> {topic.countVideos}</ListGroup.Item>
                                                <ListGroup.Item><FontAwesomeIcon icon={faQuestionCircle} title={props.t("The number of learning tasks used in the topic")}/> {topic.countQuestions}</ListGroup.Item>
                                                <ListGroup.Item><FontAwesomeIcon icon={faBook} title={props.t("The number of documents used in the topic")}/> {topic.countDocuments}</ListGroup.Item>
                                                <ListGroup.Item><FontAwesomeIcon icon={faGears} title={props.t("The number of practical tasks used in the topic")}/> {topic.countPractice}</ListGroup.Item>
                                                <div className="hr"/>
                                            </ListGroup>
                                            </Col>
                                    </Row>                        
                                </Card.Body>
                                <Card.Footer className="text-left">
                                    <Button  style={{borderRadius:"0",backgroundColor:"#1E874A", borderColor:"#1E874A"}}  onClick={()=>{showTopicDitaiks(topic); loadFlow(topic.flow)}} variant="info" title={props.t("View details topic")}>
                                        <FontAwesomeIcon icon={faBookOpen} className={'mr-1'}></FontAwesomeIcon>
                                        {props.t("Ditails topic")}
                                    </Button>
                                </Card.Footer>                                                                
                            </Card>
                        </Col>
             })}
        </Row>
        {targetTopic && <TopicFlowViewer {...props} 
            show={modalShow}
            topic = {targetTopic}                      
            flow = {currentFlow}
            onHide={() => {setModalShow(false); setTargetTopic(null); setFlow(null) }}/>}        
    </Container>);
}